import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Col, Modal, ModalBody, ModalHeader, Row, Badge } from 'reactstrap'
import ReactTooltip from 'react-tooltip'

import { resource } from 'api'
import { MAX_FILE_SIZE, FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import EmojiSelector from 'components/EmojiSelector'
import UploadFiles from 'components/UploadFiles'
import FilePreview from 'components/UploadFiles/FilePreview'
import DropZoneFileUploader from 'components/common/DropZoneFileUploader'
import ModalButtons from './ModalButtons'
import ButtonTag from '../ButtonTag'
import HtmlEditor from 'components/HtmlEditor'
import { lang } from 'utils/helpers'
import InputControls from 'components/common/InputControls'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { getContentForChannel, cleanContentHTML, getContentToClipboard } from './utils'
const _ = require('lodash')


// eslint-disable-next-line react/display-name
const TextEditor2 = (props) => {
  const {
    id, classNameWrapper, onChange, value, placeholder, company, attachments,
    buttons, removeEmojisAndAccentsValue = false, channel, variables = [],
    limit, acceptTypes = 'image/*,video/*,application/pdf', parent, cleanSms,
    currentChannelPreview, onPreviewMsg, filesPreview, dropZoneFilesHeight,
    disableEditor, externalMessage, forceCleaning, minHeight, maxHeight,
    isSmall, isTemplateValue = false, isTemplateCheck, editorCssClass, newValue,
    options = [
      "preview",  // BOTON PREVIEW
      "buttons",  // MODAL DE BOTONES
      "emojis",  // EMOJIS
      "attachments",  // ATTACHMENTS
    ]
  } = props
  const quillRef = React.useRef(null)
  const [showEmojis, setShowEmojis] = React.useState(false)
  const [valueEditor, setValueEditor] = React.useState(value)
  const [showModalFiles, setShowModalFiles] = React.useState(false)
  const [uploading, setUploading] = React.useState(false)
  const [attachmentsEditor, setAttachmentsEditor] = React.useState(attachments)
  const [currentCharacters, setCurrentCharacters] = React.useState(0)
  const [counterOverflow, serCounterOverflow] = React.useState(false)
  const onToggleEmojis = (values) => setShowEmojis(values?.requireToClose ? false : !showEmojis)
  const onToggleModalFiles = () => setShowModalFiles(!showModalFiles)
  const [showModalButtons, setShowModalButtons] = React.useState(false)
  const onToggleButtons = () => setShowModalButtons(!showModalButtons)
  const [buttonsEditor, setButtonsEditor] = React.useState(buttons)
  // const [disableVariable, setDisableVariable] = React.useState(false)
  const [variablesEditor, setVariablesEditor] = React.useState([])
  const [removeEmojisAndAccents, setRemoveEmojisAndAccents] = React.useState(removeEmojisAndAccentsValue)
  const [dropZoneIsVisible, setDropZoneIsVisible] = React.useState(false)
  const [filesErrorMessage, setFilesErrorMessage] = React.useState('')
  const [refEditor, setRefEditor] = React.useState(null)
  const [isTemplate, setIsTemplate] = React.useState(isTemplateValue)

  React.useEffect(() => {
    forceCleaning && quillRef.current && quillRef.current.setEditorContents(quillRef.current.editor, '')
  }, [forceCleaning])

  React.useEffect(() => {
    setRemoveEmojisAndAccents(removeEmojisAndAccentsValue)
  }, [removeEmojisAndAccentsValue])

  React.useEffect(() => {
    if (isTemplateValue !== isTemplate) {
      setIsTemplate(isTemplateValue)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTemplateValue])

  React.useEffect(() => {
    handleOnChange(valueEditor)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeEmojisAndAccents, currentChannelPreview, isTemplate])

  React.useEffect(() => {
    if (valueEditor) handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonsEditor])

  React.useEffect(() => {
    //if (valueEditor) handleOnChange(valueEditor)
    setButtonsEditor(buttons)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttons])

  React.useEffect(() => {
    setAttachmentsEditor(attachments)
  }, [attachments])

  React.useEffect(() => {
    if (valueEditor !== value) {
      handleOnChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  React.useEffect(() => {
    handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit])

  React.useEffect(() => {
    handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueEditor])

  const onSelectEmoji = (emoji) => {
    refEditor && refEditor.selection.insertHTML(emoji.native)
    onToggleEmojis()
  }

  const onPasteAttachments = async (attachments) => {
    let _attachments = _.clone(attachments)
    if (attachments?.length > 0 && !attachments[0].shortUrl) {
      _attachments[0].type = `${attachments[0].mimeType}/${attachments[0].mimeSubtype}`
      _attachments[0].name = attachments[0].url
      setAttachmentsEditor(_attachments)
    }

    const contentHtml = cleanContentHTML(valueEditor)
    const _content = getContentForChannel(contentHtml, { isTemplate })

    let numbersFromContent = getNumbersFromContent(_content)
    // const _disableVariable = numbersFromContent.length >= variables.length ? true : false
    // if (variables) {
    //   parent !== 'chat' && setDisableVariable(_disableVariable)
    // }
    if (numbersFromContent.length <= variables.length) {
      if (numbersFromContent.length > 0 && numbersFromContent.length !== variablesEditor.length) {
        setVariablesEditor(getNumbersFromContent(_content))
      }
    }
    else {
      numbersFromContent = parent !== 'chat' ? variablesEditor : numbersFromContent
    }

    const toClipboard = getContentToClipboard({
      text: _content,
      channel: channel,
      buttons: buttonsEditor,
      files: _attachments
    })
    const target = {
      value: _content,
      valueHtml: contentHtml,
      attachments: _attachments,
      toClipboard: toClipboard,
      counterOverflow: channel === 'whatsapp' || channel === 'sms' ? toClipboard.length > limit : _content.length > limit,
      buttons: buttonsEditor,
      variables: numbersFromContent,
      removeEmojisAndAccents,
      isTemplate
    }

    if (channel === 'whatsapp' || channel === 'sms') {
      setCurrentCharacters(toClipboard.length)
      serCounterOverflow(toClipboard.length > limit)
    } else {
      setCurrentCharacters(target.value.length)
      serCounterOverflow(target.value.length > limit)
    }
    if (showEmojis) onToggleEmojis()
    onChange(target)
    setAttachmentsEditor(_attachments)
  }

  const handleOnChange = (content = '') => {
    const contentHtml = cleanContentHTML(content)
    const _content = getContentForChannel(contentHtml, { isTemplate })

    let _attachments = _.clone(attachments?.length > 0 ? attachments : attachmentsEditor)
    if (attachments?.length > 0 && !attachments[0].shortUrl) {
      _attachments[0].type = `${attachments[0].mimeType}/${attachments[0].mimeSubtype}`
      _attachments[0].name = attachments[0].url
      setAttachmentsEditor(_attachments)
    }
    const toClipboard = getContentToClipboard({
      text: _content,
      channel: channel,
      buttons: buttonsEditor,
      files: _attachments
    })
    let numbersFromContent = getNumbersFromContent(contentHtml)
    // const _disableVariable = numbersFromContent.length >= variables.length ? true : false
    // if (variables) {
    //   parent !== 'chat' && setDisableVariable(_disableVariable)
    // }
    if (numbersFromContent.length <= variables.length) {
      if (numbersFromContent.length > 0 && numbersFromContent.length !== variablesEditor.length) {
        setVariablesEditor(getNumbersFromContent(contentHtml))
      }
    }
    else {
      numbersFromContent = parent !== 'chat' ? variablesEditor : numbersFromContent
    }

    const target = {
      value: _content.replace(/\n/g, '&nbsp;'),
      valueHtml: contentHtml.replace(/\n/g, '&nbsp;'),
      attachments: _attachments,
      toClipboard: toClipboard,
      counterOverflow: channel === 'whatsapp' || channel === 'sms' ? toClipboard.length > limit : _content.length > limit,
      buttons: buttonsEditor,
      variables: numbersFromContent,
      removeEmojisAndAccents,
      isTemplate
    }

    if (showEmojis) onToggleEmojis()
    onChange(target)
    if (channel === 'whatsapp' || channel === 'sms') {
      setCurrentCharacters(toClipboard.length)
      serCounterOverflow(toClipboard.length > limit)
    } else {
      setCurrentCharacters(target.value.length)
      serCounterOverflow(target.value.length > limit)
    }
  }

  const onUploadFiles = async (files) => {
    setUploading(true)
    let _attachments = []
    try {
      if (files.length > 0) {
        const formData = new FormData()
        const dataBody = {
          companyType: company.type,
          companyToken: company.hash,
          typeUpload: 'userFile',
        }

        formData.append('data', JSON.stringify(dataBody))
        formData.append('files', files[0].file)

        const { data } = await resource.uploadFiles(formData)

        _attachments = [
          {
            _id: false,
            ...data.attachments[0],
            url: data.attachments[0].url,
            urlLong: data.attachments[0].urlLong,
            mimeType: data.attachments[0].mimeType,
            mimeSubtype: data.attachments[0].mimeSubtype,
            fileId: data.attachments[0].fileId,
            type: `${data.attachments[0].mimeType}/${data.attachments[0].mimeSubtype}`,
            name: data.attachments[0].name || data.attachments[0].url,
          }
        ]
      }

      const contentHtml = cleanContentHTML(valueEditor)
      const _content = getContentForChannel(contentHtml, { isTemplate })

      let numbersFromContent = getNumbersFromContent(_content)
      // const _disableVariable = numbersFromContent.length >= variables.length ? true : false
      // if (variables) {
      //   parent !== 'chat' && setDisableVariable(_disableVariable)
      // }
      if (numbersFromContent.length <= variables.length) {
        if (numbersFromContent.length > 0 && numbersFromContent.length !== variablesEditor.length) {
          setVariablesEditor(getNumbersFromContent(_content))
        }
      }
      else {
        numbersFromContent = parent !== 'chat' ? variablesEditor : numbersFromContent
      }

      const toClipboard = getContentToClipboard({
        text: _content,
        channel: channel,
        buttons: buttonsEditor,
        files: _attachments
      })
      const target = {
        value: _content,
        valueHtml: contentHtml,
        attachments: _attachments,
        toClipboard: toClipboard,
        counterOverflow: channel === 'whatsapp' || channel === 'sms' ? toClipboard.length > limit : _content.length > limit,
        buttons: buttonsEditor,
        variables: numbersFromContent,
        removeEmojisAndAccents,
        isTemplate
      }
      if (channel === 'whatsapp' || channel === 'sms') {
        setCurrentCharacters(toClipboard.length)
        serCounterOverflow(toClipboard.length > limit)
      } else {
        setCurrentCharacters(target.value.length)
        serCounterOverflow(target.value.length > limit)
      }
      if (showEmojis) onToggleEmojis()
      onChange(target)
      setAttachmentsEditor(_attachments)
    } catch (error) {
      console.error(error.message)
    }

    setUploading(false)
  }

  const getNumbersFromContent = (content = '') => (([...new Set(content.match(/{{[0-9]+}}/g))] || []).map((x) => x.match(/[0-9]+/)))

  const handleDragEnter = () => setDropZoneIsVisible(true)
  const handleDragLeave = () => setDropZoneIsVisible(false)

  const withAttachments = options.includes('attachments')

  return (
    <div
      className={`text-editor-wrapper ${classNameWrapper ? classNameWrapper : ''}`}
      onDragEnter={withAttachments ? handleDragEnter : null}
      onDragLeave={withAttachments ? handleDragLeave : null}
    >
      {dropZoneIsVisible ? (
        <DropZoneFileUploader
          height={dropZoneFilesHeight}
          maxSize={FILE_MAX_SIZE_CONVERSATION}
          uploadFiles={onUploadFiles}
          onError={setFilesErrorMessage}
          onHiddenDropZone={() => setDropZoneIsVisible(false)}
        />
      ): (
        <>
          <div className={`text-editor-back ${disableEditor ? '__disabled' : ''}`}>
            <div
              className='text-editor-wrapper-inner'
              onClick={() => {
                if (disableEditor)
                  externalMessage()
                else
                  return(false)
              }}
            >
              <HtmlEditor
                id={id}
                className={`text-editor-control ${options.find(option => option === 'preview') ? 'previewMsg-control' : ''} ${disableEditor ? 'disable-editor' : ''}`}
                defaultValue={value ? value : ''}
                value={newValue || ''}
                placeholder={placeholder}
                withAttachments={withAttachments}
                onPasteAttachments={onPasteAttachments}
                onChange={setValueEditor}
                readonly={disableEditor}
                setInstance={setRefEditor}
                channel={channel}
                minHeight={minHeight}
                maxHeight={maxHeight}
                isSmall={isSmall}
                editorCssClass={editorCssClass}
                isTemplate={isTemplate}
                displayAddVars={!!variables.length}
                enter='P'
              />

              <span className={`counter ${counterOverflow && limit ? 'counter-red' : 'counter-normal'}`}>{limit ? `${currentCharacters}/${limit}` : `${currentCharacters}`}</span>

              <div className='upload-files-feedback'>
                {(!filesErrorMessage && uploading) ? (
                  <div className='upload-files-feedback__spinner-wrapper'>
                    <Nixi1Spinner width='20px' height='20px' />
                  </div>
                ) : null}
                {filesErrorMessage ? <p className='files-error'>{I18n.t(filesErrorMessage)}</p> : null}
              </div>
            </div>

            <Row className='d-flex mt-1 pl-3 pr-3'>
              {options.find(option => option === 'preview') && (
                <Col className='col-md-auto pl-0 pr-0 button-tag-preview'>
                  <ButtonTag onClick={onPreviewMsg} value={I18n.t('dashboard_preview')} />
                </Col>
              )}
              <Col className='col-md-auto pl-0 pr-0 ml-auto'>
                <div className='buttons-icon'>
                  {/* {variables.length > 0 && (
                    <small className={`text-muted pointer variable ${disableVariable && 'blocked'}`} onClick={onClickVariable}>
                      {`{{VAR}}`}
                    </small>
                  )} */}
                  {withAttachments && (
                    <small className='text-muted pointer attachments-wrapper' onClick={()=> !disableEditor && onToggleModalFiles()}>
                      {channel === 'facebook' ? (
                        <>
                          <img src={'./img/icons/editor-image.svg'} alt='button' />
                          { attachmentsEditor?.length > 0
                            ?
                            <div className='badge'>
                              <Badge color={'warning'} pill>
                                {attachmentsEditor?.length}
                              </Badge>
                            </div>
                            :
                            null
                          }
                        </>
                      ) : (
                        <>
                          <img src={'./img/icons/editor-file.svg'} alt='button' />
                          { attachmentsEditor?.length > 0
                            ?
                            <div className='badge'>
                              <Badge color={'warning'} pill>
                                {attachmentsEditor?.length}
                              </Badge>
                            </div>
                            :
                            null
                          }
                        </>
                      )}
                    </small>
                  )}
                  {options.includes('emojis') && (
                    <small id='emojiIconEditorWrapper' className='text-muted pointer' onClick={onToggleEmojis}>
                      <img id='emojiIconEditor' src='./img/icons/editor-emoji.svg' alt='button' />
                    </small>
                  )}
                  {options.includes('buttons') && (
                    <small className='text-muted pointer buttons-wrapper' onClick={()=> !disableEditor && onToggleButtons() }>
                      <img src={'./img/icons/editor-button.svg'} alt='button' />
                      { buttonsEditor && buttonsEditor.length > 0
                        ?
                        <div className='badge'>
                          <Badge color={'warning'} pill>
                            {buttonsEditor.length}
                          </Badge>
                        </div>
                        :
                        null
                      }
                    </small>
                  )}
                </div>
              </Col>
            </Row>

            <EmojiSelector showEmojis={showEmojis} handleToggle={onToggleEmojis} handleSelect={onSelectEmoji} />

            {showModalFiles ? (
              <Modal isOpen={showModalFiles} toggle={onToggleModalFiles} centered={true}>
                <ModalHeader>{I18n.t('dashboard_upload-files')}</ModalHeader>
                <ModalBody>
                  <UploadFiles
                    uploading={uploading}
                    uploadFiles={onUploadFiles}
                    multiple={false}
                    acceptTypes={acceptTypes}
                    cancel={() => setShowModalFiles(false)}
                    filesUploaded={attachmentsEditor}
                    onRemoveUploadedFile={() => onUploadFiles([])}
                    removeOnDrop={true}
                    maxSize={MAX_FILE_SIZE}
                    messageErrorSize={I18n.t('file-too-big')}
                  />
                </ModalBody>
              </Modal>
            ) : null }
            <ModalButtons
              isOpenModal={showModalButtons}
              setIsOpenModal={onToggleButtons}
              templateButtons={buttonsEditor || []}
              setTemplateButtons={setButtonsEditor}
            />
          </div>

          {
            cleanSms && (
              <Row className='mt-2 pl-3 pr-3'>
                <div className='sms-check' data-tip={I18n.t('tooltip_sms_remove_chars')}>
                  <InputControls
                    label={I18n.t('checkbox_sms_remove_chars')}
                    value={removeEmojisAndAccentsValue}
                    onChange={setRemoveEmojisAndAccents}
                  />
                </div>
                <ReactTooltip multiline={true} />
              </Row>
            )
          }

          {filesPreview && attachmentsEditor && attachmentsEditor.length > 0 ? (
            <Row className='mt-1 preview-files'>
              {attachmentsEditor.map((file, key) => (
                <FilePreview
                  key={file.url + key}
                  id={key}
                  url={file.urlLong || file.url}
                  thumb={file.thumb}
                  shortUrl={file.url || file.urlLong}
                  type={file.mime}
                  mimeType={file.mimeType}
                  mimeSubtype={file.mimeSubtype}
                  extension={file.extension}
                  disabled={true}
                  withVirus={file.withVirus}
                />
              ))}
            </Row>
          ) : null}

          {
            channel === 'chatmail' && isTemplateCheck &&
            <>
              <div className='chatmail-check' data-tip={lang('tooltip_chatmail_template_default')}>
                <InputControls
                  label={I18n.t('label_chatmail_template_default')}
                  value={isTemplateValue}
                  onChange={setIsTemplate}
                />
                <ReactTooltip multiline={true} />
              </div>
            </>
          }
        </>
      )}
    </div>
  )
}
export default TextEditor2
